import './index.scss';
import { getJsSdk } from '../../service/share';
// import * as Toast from '../Toast';
import zzc from '../../native/zzc';
import utilUa from '../../util-lib/ua';
import getShareTipsContent from './share-tips-contents';

class Share {
  constructor(params = {}) {
    const defaultParams = {
      shareTitle: '租租车,国际租车,全球华人的出境自驾游租车平台',
      shareUrl: 'https://m.zuzuche.com',
      shareImg: 'https://imgcdn50.zuzuche.com/static/10/08/03814124cd32d78595198db8c7106106.png',
      shareContent: '租租车(zuzuche.com)是全球华人的出境自驾游租车平台，已为超过1000万中国用户提供美国租车、德国租车、法国租车、泰国租车、澳洲租车等全球200个国家的租车在线预订。所有车型均由国际知名连锁租车公司提供，比去HERTZ AVIS等官网预订优惠10%-30%以上！',
      shareTipsContent: getShareTipsContent('default'),
      sharePlatform: ['wxsession', 'wxtimeline', 'copy'],
      jsApiListArr: [
        'updateAppMessageShareData',
        'updateTimelineShareData'
      ],
      onSuccess: () => {
        //   console.warn(`微信分享成功！${res}`);
      }
    };
    this.params = {
      ...defaultParams,
      ...params
    };
    this._init();
  }

  _init() {
    const uaObject = utilUa() || {};
    const browser = uaObject.browser;
    switch (browser.name) {
      case 'WeChat':
        this._getJsSdk();
        break;
      case 'zuzuche':
      case 'tantutravel':
      case 'tantumap':
        this._zzcShare();
        break;
      default:
        // console.warn('非微信、租租车app环境，加载分享失败！');
        break;
    }
  }

  _getJsSdk() {
    getJsSdk().then((res) => {
      const jssdk = res.getWechatDefaultJsSdkConfig.data;
      this._wxShare(jssdk);
    }).catch((error) => {
      // Toast.show({
      //   content: rej.message
      // });
      // eslint-disable-next-line
      console.error(error);
    });
  }

  /**
     * 微信自定义分享
     */
  _wxShare(jssdk) {
    const wx = window.wx;

    if (!jssdk || !wx) return;

    const {
      appId,
      timestamp,
      nonceStr,
      signature
      // jsApiList
    } = jssdk;

    wx.config({
      debug: false,
      appId,
      timestamp,
      nonceStr,
      signature,
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'hideMenuItems',
        'showMenuItems'
      ]
    });
    wx.ready(() => {
      this._configWxShare(this.params);
    });
    // 隐藏所有非基础按钮接口
    wx.hideAllNonBaseMenuItem();

    // 要显示的菜单项
    wx.showMenuItems({
      menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:favorite']
    });

    wx.error(() => {
    //   console.error(`微信验证失败！${res.errMsg}`);
    });
  }

  _configWxShare = (config) => {
    const wx = window.wx;
    if (!wx) return;
    const {
      shareTitle,
      shareUrl,
      shareImg,
      shareContent,
      onSuccess
    } = config;

    [
      'updateAppMessageShareData',
      'updateTimelineShareData'
    ].forEach((item) => {
      // fix https://logger.zuzuche.com/tantu/poi-m-web-client/issues/34389/?environment=prod
      // reason: https://www.jianshu.com/p/ea35c1460af2
      if (typeof wx[item] !== 'function') {
        return false;
      }

      return wx[item]({
        title: shareTitle,
        desc: shareContent,
        link: shareUrl,
        imgUrl: shareImg,
        success: (data) => {
          onSuccess && onSuccess(data);
          this.hideShareTips();
        }
      });
    });
  }

  /**
     * 租租车分享
     */
  _zzcShare() {
    const {
      shareTitle,
      shareUrl,
      shareImg,
      shareContent,
      sharePlatform,
      shareMiniName,
      sharePath
    } = this.params;

    const baseShare = {
      title: '分享',
      type: 'share',
      shareTitle,
      shareContent,
      shareIcon: shareImg,
      sharePlatform,
      shareURL: shareUrl
    };

    if (sharePlatform.includes('miniProgram') && shareMiniName && sharePath) {
      baseShare.userName = shareMiniName;
      baseShare.path = sharePath;
    }

    zzc.call('appCustomRightBarList', {
      customItems: [
        {
          title: '消息',
          type: 'systemMessage'
        },
        {
          title: '首页', type: 'home'
        },
        {
          ...baseShare
        },
        {
          title: '问题反馈',
          type: 'feedback'
        },
        {
          title: '客服中心', type: 'contactCS'
        },
        {
          title: '服务代码',
          type: 'serviceCode'
        }],
      listener: (res) => {
        if (res.buttonIndex === 2) {
          this.toShare();
        }
      }
    });
  }

  /**
   * 主动触发分享事件
   */
  toShare(shareConfig) {
    const config = {
      ...this.params,
      ...shareConfig
    };
    const {
      shareTitle,
      shareUrl,
      shareImg,
      shareContent,
      shareTipsContent,
      sharePlatform,
      shareMiniName,
      sharePath,
      onSuccess
    } = config;
    const { browser } = utilUa();

    if (browser.name === 'WeChat') {
      if (shareConfig) {
        this._configWxShare(shareConfig);
      }
      this.showShareTips(shareTipsContent);
    } else if (browser.name === 'zuzuche' || browser.name === 'tantutravel' || browser.name === 'tantumap') {
      const baseShare = {
        title: shareTitle,
        content: shareContent,
        photo: shareImg,
        shareUrl,
        sharePlatform
      };

      if (shareMiniName && sharePath) {
        baseShare.userName = shareMiniName;
        baseShare.path = sharePath;
      }
      zzc.call('Share', {
        ...baseShare,
        success(response) {
          onSuccess && onSuccess(response);
        }
      });
    } else {
      this.showShareTips(shareTipsContent);
    }
    // switch (browser.name) {
    //   case 'WeChat':
    //     if (shareConfig) {
    //       this._configWxShare(shareConfig);
    //     }
    //     this.showShareTips(shareTipsContent);
    //     break;
    //   case 'zuzuche':
    //   case 'tantutravel':
    //   case 'tantumap':
    //     const baseShare = {
    //       title: shareTitle,
    //       content: shareContent,
    //       photo: shareImg,
    //       shareUrl,
    //       sharePlatform
    //     };
    //
    //     if (shareMiniName && sharePath) {
    //       baseShare.userName = shareMiniName;
    //       baseShare.path = sharePath;
    //     }
    //     zzc.call('Share', {
    //       ...baseShare,
    //       success(response) {
    //         onSuccess && onSuccess(response);
    //       }
    //     });
    //     break;
    //   default:
    //     this.showShareTips(shareTipsContent);
    //     break;
    // }
  }

  /**
   * 显示微信分享提示
   */
  showShareTips(content) {
    const shareDom = document.getElementById('component-wx-share-tips') || null;
    const shareHide = () => {
      const shareDiv = document.getElementById('component-wx-share-tips');
      shareDiv.style.display = 'none';
    };
    if (!shareDom) {
      const sectionDom = document.createElement('section');
      sectionDom.className = 'component-wx-share-tips';
      sectionDom.id = 'component-wx-share-tips';
      sectionDom.onclick = shareHide;
      sectionDom.innerHTML = content;
      document.body.appendChild(sectionDom);
    } else {
      const shareDiv = document.getElementById('component-wx-share-tips');
      shareDiv.innerHTML = content;
      shareDiv.style.display = 'block';
    }
  }

  /**
     * 隐藏微信分享提示
     */
  hideShareTips() {
    const shareDom = document.getElementById('component-wx-share-tips');
    if (shareDom) {
      shareDom.style.display = 'none';
    }
  }

  bindShowShareTips = (fn) => {
    if (!fn || typeof fn !== 'function') return;
    this.showShareTips = fn;
  }

  bindHideShareTips = (fn) => {
    if (!fn || typeof fn !== 'function') return;
    this.hideShareTips = fn;
  }
}

export {
  getShareTipsContent
};

export default Share;
